import { render, staticRenderFns } from "./device-kindle-search.component.vue?vue&type=template&id=b0a30dd2"
import script from "./device-kindle-search.component.vue?vue&type=script&lang=ts"
export * from "./device-kindle-search.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports